const config = {
  RECAPTCHA_SITE_KEY: "6LcAPfUqAAAAAFJuohMmB7K31piRAq0FtkYkyTJP",
  API_SIGNIN_URL:
    "https://apis.sihs.org.pk/api/EventPortal/Login?DeviceID={DeviceID}&UserID={UserID}&Password={Password}",
  API_FORGOT_PASSWORD_URL:
    "https://apis.sihs.org.pk/api/EventPortal/EventForgotPassword?DeviceID={DeviceID}&UserID={UserID}",
  API_FORGOT_PASSWORD_VERIFY_URL:
    "https://apis.sihs.org.pk/api/EventPortal/EventForgotPasswordVerify?DeviceID={DeviceID}&UserID={UserID}&OTP={OTP}",
  API_UPDATE_PASSWORD_URL:
    "https://apis.sihs.org.pk/api/EventPortal/EventUpdatePassword?DeviceID={DeviceID}&UserID={UserID}&Password={Password}",
  API_REGISTER_URL:
    "https://apis.sihs.org.pk/api/EventPortal/EventRegister?DeviceID={DeviceID}&UserID={UserID}&Fullname={Fullname}&Password={Password}",
  API_VERIFY_EMAIL:
    "https://apis.sihs.org.pk/api/EventPortal/EventEmailVerify?DeviceID={DeviceID}&UserID={UserID}&OTP={OTP}",
  API_PROFILE_EXISTS_URL:
    "https://apis.sihs.org.pk/api/EventPortal/ProfileExists?DeviceID={DeviceID}&UserID={UserID}&EventID={EventID}&ApplicantID={ApplicantID}",
  API_PROFILE_CREATE_URL:
    "https://apis.sihs.org.pk/api/EventPortal/ProfileCreate?DeviceID={DeviceID}&UserID={UserID}&EventID={EventID}&ApplicantID={ApplicantID}&Name={Name}&FatherName={FatherName}&Nationality={Nationality}&PartcipantType={PartcipantType}&PresenterType={PresenterType}&PMDCReg={PMDCReg}&Designation={Designation}&Institution={Institution}&Faculty={Faculty}&Department={Department}&Address={Address}&Country={Country}&PostCode={PostCode}&City={City}&Phone={Phone}&Mobile={Mobile}&Fax={Fax}&AltEmail={AltEmail}&Gender={Gender}",
  API_WORKSHOP_LIST_URL:
    "https://apis.sihs.org.pk/api/EventPortal/WorkshopsList?EventID={EventID}&ApplicantID={ApplicantID}",
  API_GET_PROFILE_URL:
    "https://apis.sihs.org.pk/api/EventPortal/GetProfile?DeviceID={DeviceID}&UserID={UserID}&EventID={EventID}&ApplicantID={ApplicantID}",
  API_GET_ABSTRACT_URL:
    "https://apis.sihs.org.pk/api/EventPortal/GetAbstracts?DeviceID={DeviceID}&UserID={UserID}&EventID={EventID}&ApplicantID={ApplicantID}",
  API_SAVE_ABSTRACT_URL:
    "https://apis.sihs.org.pk/api/EventPortal/AbstractSave",
  API_REMOVE_ABSTRACT_URL:
    "https://apis.sihs.org.pk/api/EventPortal/RemoveAbstract?DeviceID={DeviceID}&UserID={UserID}&EventID={EventID}&ApplicantID={ApplicantID}&pk={pk}",
  API_GET_ABSTRACT_SPECIALTY_URL:
    "https://apis.sihs.org.pk/api/EventPortal/SpecialityList?EventID={EventID}&ApplicantID={ApplicantID}",
  API_GET_ABSTRACT_SUBSPECIALTY_URL:
    "https://apis.sihs.org.pk/api/EventPortal/SubSpecialityList?SupecialityID={SupecialityID}",
  API_SUBMIT_ABSTRACT_URL:
    "https://apis.sihs.org.pk/api/EventPortal/SubmitAbstract?DeviceID={DeviceID}&UserID={UserID}&EventID={EventID}&ApplicantID={ApplicantID}&pk={pk}",
  API_UPDATE_ABSTRACT_URL:
    "https://apis.sihs.org.pk/api/EventPortal/AbstractUpdate",
  API_CHECK_AVAILABLE_SEAT_URL:
    "https://apis.sihs.org.pk/api/EventPortal/SeatAvailable?DeviceID={DeviceID}&UserID={UserID}&workshopID={workshopID}",
  API_ADD_TO_ORDER_URL:
    "https://apis.sihs.org.pk/api/EventPortal/CheckOut?DeviceID={DeviceID}&UserID={UserID}&workshopIDs={workshopIDs}&ApplicantID={ApplicantID}&EventID={EventID}",
  API_INITIATE_PAYMENT_URL: "https://reactapi.sihs.org.pk/api/initiatePayment",
  API_FINALIZE_PAYMENT_URL: "https://reactapi.sihs.org.pk/api/finalizePayment",
  API_LAST_DATE: "https://apis.sihs.org.pk/api/EventPortal/LastDates?EventID={EventID}&typ={typ}",
};

export default config;
